

if(typeof lazySizes === 'undefined'){
	/*! lazysizes - v4.1.8 */
	!function (a, b) { var c = b(a, a.document); a.lazySizes = c, "object" == typeof module && module.exports && (module.exports = c) }(window, function (a, b) { "use strict"; if (b.getElementsByClassName) { var c, d, e = b.documentElement, f = a.Date, g = a.HTMLPictureElement, h = "addEventListener", i = "getAttribute", j = a[h], k = a.setTimeout, l = a.requestAnimationFrame || k, m = a.requestIdleCallback, n = /^picture$/i, o = ["load", "error", "lazyincluded", "_lazyloaded"], p = {}, q = Array.prototype.forEach, r = function (a, b) { return p[b] || (p[b] = new RegExp("(\\s|^)" + b + "(\\s|$)")), p[b].test(a[i]("class") || "") && p[b] }, s = function (a, b) { r(a, b) || a.setAttribute("class", (a[i]("class") || "").trim() + " " + b) }, t = function (a, b) { var c; (c = r(a, b)) && a.setAttribute("class", (a[i]("class") || "").replace(c, " ")) }, u = function (a, b, c) { var d = c ? h : "removeEventListener"; c && u(a, b), o.forEach(function (c) { a[d](c, b) }) }, v = function (a, d, e, f, g) { var h = b.createEvent("Event"); return e || (e = {}), e.instance = c, h.initEvent(d, !f, !g), h.detail = e, a.dispatchEvent(h), h }, w = function (b, c) { var e; !g && (e = a.picturefill || d.pf) ? (c && c.src && !b[i]("srcset") && b.setAttribute("srcset", c.src), e({ reevaluate: !0, elements: [b] })) : c && c.src && (b.src = c.src) }, x = function (a, b) { return (getComputedStyle(a, null) || {})[b] }, y = function (a, b, c) { for (c = c || a.offsetWidth; c < d.minSize && b && !a._lazysizesWidth;)c = b.offsetWidth, b = b.parentNode; return c }, z = function () { var a, c, d = [], e = [], f = d, g = function () { var b = f; for (f = d.length ? e : d, a = !0, c = !1; b.length;)b.shift()(); a = !1 }, h = function (d, e) { a && !e ? d.apply(this, arguments) : (f.push(d), c || (c = !0, (b.hidden ? k : l)(g))) }; return h._lsFlush = g, h }(), A = function (a, b) { return b ? function () { z(a) } : function () { var b = this, c = arguments; z(function () { a.apply(b, c) }) } }, B = function (a) { var b, c = 0, e = d.throttleDelay, g = d.ricTimeout, h = function () { b = !1, c = f.now(), a() }, i = m && g > 49 ? function () { m(h, { timeout: g }), g !== d.ricTimeout && (g = d.ricTimeout) } : A(function () { k(h) }, !0); return function (a) { var d; (a = !0 === a) && (g = 33), b || (b = !0, d = e - (f.now() - c), d < 0 && (d = 0), a || d < 9 ? i() : k(i, d)) } }, C = function (a) { var b, c, d = 99, e = function () { b = null, a() }, g = function () { var a = f.now() - c; a < d ? k(g, d - a) : (m || e)(e) }; return function () { c = f.now(), b || (b = k(g, d)) } }; !function () { var b, c = { lazyClass: "lazyload", loadedClass: "lazyloaded", loadingClass: "lazyloading", preloadClass: "lazypreload", errorClass: "lazyerror", autosizesClass: "lazyautosizes", srcAttr: "data-src", srcsetAttr: "data-srcset", sizesAttr: "data-sizes", minSize: 40, customMedia: {}, init: !0, expFactor: 1.5, hFac: .8, loadMode: 2, loadHidden: !0, ricTimeout: 0, throttleDelay: 125 }; d = a.lazySizesConfig || a.lazysizesConfig || {}; for (b in c) b in d || (d[b] = c[b]); a.lazySizesConfig = d, k(function () { d.init && F() }) }(); var D = function () { var g, l, m, o, p, y, D, F, G, H, I, J, K = /^img$/i, L = /^iframe$/i, M = "onscroll" in a && !/(gle|ing)bot/.test(navigator.userAgent), N = 0, O = 0, P = 0, Q = -1, R = function (a) { P-- , (!a || P < 0 || !a.target) && (P = 0) }, S = function (a) { return null == J && (J = "hidden" == x(b.body, "visibility")), J || "hidden" != x(a.parentNode, "visibility") && "hidden" != x(a, "visibility") }, T = function (a, c) { var d, f = a, g = S(a); for (F -= c, I += c, G -= c, H += c; g && (f = f.offsetParent) && f != b.body && f != e;)(g = (x(f, "opacity") || 1) > 0) && "visible" != x(f, "overflow") && (d = f.getBoundingClientRect(), g = H > d.left && G < d.right && I > d.top - 1 && F < d.bottom + 1); return g }, U = function () { var a, f, h, j, k, m, n, p, q, r, s, t, u = c.elements; if ((o = d.loadMode) && P < 8 && (a = u.length)) { for (f = 0, Q++; f < a; f++)if (u[f] && !u[f]._lazyRace) if (!M || c.prematureUnveil && c.prematureUnveil(u[f])) aa(u[f]); else if ((p = u[f][i]("data-expand")) && (m = 1 * p) || (m = O), r || (r = !d.expand || d.expand < 1 ? e.clientHeight > 500 && e.clientWidth > 500 ? 500 : 370 : d.expand, c._defEx = r, s = r * d.expFactor, t = d.hFac, J = null, O < s && P < 1 && Q > 2 && o > 2 && !b.hidden ? (O = s, Q = 0) : O = o > 1 && Q > 1 && P < 6 ? r : N), q !== m && (y = innerWidth + m * t, D = innerHeight + m, n = -1 * m, q = m), h = u[f].getBoundingClientRect(), (I = h.bottom) >= n && (F = h.top) <= D && (H = h.right) >= n * t && (G = h.left) <= y && (I || H || G || F) && (d.loadHidden || S(u[f])) && (l && P < 3 && !p && (o < 3 || Q < 4) || T(u[f], m))) { if (aa(u[f]), k = !0, P > 9) break } else !k && l && !j && P < 4 && Q < 4 && o > 2 && (g[0] || d.preloadAfterLoad) && (g[0] || !p && (I || H || G || F || "auto" != u[f][i](d.sizesAttr))) && (j = g[0] || u[f]); j && !k && aa(j) } }, V = B(U), W = function (a) { var b = a.target; if (b._lazyCache) return void delete b._lazyCache; R(a), s(b, d.loadedClass), t(b, d.loadingClass), u(b, Y), v(b, "lazyloaded") }, X = A(W), Y = function (a) { X({ target: a.target }) }, Z = function (a, b) { try { a.contentWindow.location.replace(b) } catch (c) { a.src = b } }, $ = function (a) { var b, c = a[i](d.srcsetAttr); (b = d.customMedia[a[i]("data-media") || a[i]("media")]) && a.setAttribute("media", b), c && a.setAttribute("srcset", c) }, _ = A(function (a, b, c, e, f) { var g, h, j, l, o, p; (o = v(a, "lazybeforeunveil", b)).defaultPrevented || (e && (c ? s(a, d.autosizesClass) : a.setAttribute("sizes", e)), h = a[i](d.srcsetAttr), g = a[i](d.srcAttr), f && (j = a.parentNode, l = j && n.test(j.nodeName || "")), p = b.firesLoad || "src" in a && (h || g || l), o = { target: a }, s(a, d.loadingClass), p && (clearTimeout(m), m = k(R, 2500), u(a, Y, !0)), l && q.call(j.getElementsByTagName("source"), $), h ? a.setAttribute("srcset", h) : g && !l && (L.test(a.nodeName) ? Z(a, g) : a.src = g), f && (h || l) && w(a, { src: g })), a._lazyRace && delete a._lazyRace, t(a, d.lazyClass), z(function () { var b = a.complete && a.naturalWidth > 1; p && !b || (b && s(a, "ls-is-cached"), W(o), a._lazyCache = !0, k(function () { "_lazyCache" in a && delete a._lazyCache }, 9)), "lazy" == a.loading && P-- }, !0) }), aa = function (a) { if (!a._lazyRace) { var b, c = K.test(a.nodeName), e = c && (a[i](d.sizesAttr) || a[i]("sizes")), f = "auto" == e; (!f && l || !c || !a[i]("src") && !a.srcset || a.complete || r(a, d.errorClass) || !r(a, d.lazyClass)) && (b = v(a, "lazyunveilread").detail, f && E.updateElem(a, !0, a.offsetWidth), a._lazyRace = !0, P++ , _(a, b, f, e, c)) } }, ba = C(function () { d.loadMode = 3, V() }), ca = function () { 3 == d.loadMode && (d.loadMode = 2), ba() }, da = function () { if (!l) { if (f.now() - p < 999) return void k(da, 999); l = !0, d.loadMode = 3, V(), j("scroll", ca, !0) } }; return { _: function () { p = f.now(), c.elements = b.getElementsByClassName(d.lazyClass), g = b.getElementsByClassName(d.lazyClass + " " + d.preloadClass), j("scroll", V, !0), j("resize", V, !0), a.MutationObserver ? new MutationObserver(V).observe(e, { childList: !0, subtree: !0, attributes: !0 }) : (e[h]("DOMNodeInserted", V, !0), e[h]("DOMAttrModified", V, !0), setInterval(V, 999)), j("hashchange", V, !0), ["focus", "mouseover", "click", "load", "transitionend", "animationend", "webkitAnimationEnd"].forEach(function (a) { b[h](a, V, !0) }), /d$|^c/.test(b.readyState) ? da() : (j("load", da), b[h]("DOMContentLoaded", V), k(da, 2e4)), c.elements.length ? (U(), z._lsFlush()) : V() }, checkElems: V, unveil: aa, _aLSL: ca } }(), E = function () { var a, c = A(function (a, b, c, d) { var e, f, g; if (a._lazysizesWidth = d, d += "px", a.setAttribute("sizes", d), n.test(b.nodeName || "")) for (e = b.getElementsByTagName("source"), f = 0, g = e.length; f < g; f++)e[f].setAttribute("sizes", d); c.detail.dataAttr || w(a, c.detail) }), e = function (a, b, d) { var e, f = a.parentNode; f && (d = y(a, f, d), e = v(a, "lazybeforesizes", { width: d, dataAttr: !!b }), e.defaultPrevented || (d = e.detail.width) && d !== a._lazysizesWidth && c(a, f, e, d)) }, f = function () { var b, c = a.length; if (c) for (b = 0; b < c; b++)e(a[b]) }, g = C(f); return { _: function () { a = b.getElementsByClassName(d.autosizesClass), j("resize", g) }, checkElems: g, updateElem: e } }(), F = function () { F.i || (F.i = !0, E._(), D._()) }; return c = { cfg: d, autoSizer: E, loader: D, init: F, uP: w, aC: s, rC: t, hC: r, fire: v, gW: y, rAF: z } } });
	/*! ls.rias.min.ks - v4.1.8 */
	!function (a, b) { var c = function () { b(a.lazySizes), a.removeEventListener("lazyunveilread", c, !0) }; b = b.bind(null, a, a.document), "object" == typeof module && module.exports ? b(require("lazysizes")) : a.lazySizes ? c() : a.addEventListener("lazyunveilread", c, !0) }(window, function (a, b, c) { "use strict"; function d(b, c) { var d, e, f, g, h = a.getComputedStyle(b); e = b.parentNode, g = { isPicture: !(!e || !m.test(e.nodeName || "")) }, f = function (a, c) { var d = b.getAttribute("data-" + a); if (!d) { var e = h.getPropertyValue("--ls-" + a); e && (d = e.trim()) } if (d) { if ("true" == d) d = !0; else if ("false" == d) d = !1; else if (l.test(d)) d = parseFloat(d); else if ("function" == typeof j[a]) d = j[a](b, d); else if (q.test(d)) try { d = JSON.parse(d) } catch (a) { } g[a] = d } else a in j && "function" != typeof j[a] ? g[a] = j[a] : c && "function" == typeof j[a] && (g[a] = j[a](b, d)) }; for (d in j) f(d); return c.replace(p, function (a, b) { b in g || f(b, !0) }), g } function e(a, b) { var c = [], d = function (a, c) { return k[typeof b[c]] ? b[c] : a }; return c.srcset = [], b.absUrl && (s.setAttribute("href", a), a = s.href), a = ((b.prefix || "") + a + (b.postfix || "")).replace(p, d), b.widths.forEach(function (d) { var e = b.widthmap[d] || d, f = b.aspectratio || b.ratio, g = !b.aspectratio && j.traditionalRatio, h = { u: a.replace(n, e).replace(o, f ? g ? Math.round(d * f) : Math.round(d / f) : ""), w: d }; c.push(h), c.srcset.push(h.c = h.u + " " + d + "w") }), c } function f(a, c, d) { var f = 0, g = 0, h = d; if (a) { if ("container" === c.ratio) { for (f = h.scrollWidth, g = h.scrollHeight; !(f && g || h === b);)h = h.parentNode, f = h.scrollWidth, g = h.scrollHeight; f && g && (c.ratio = g / f) } a = e(a, c), a.isPicture = c.isPicture, u && "IMG" == d.nodeName.toUpperCase() ? d.removeAttribute(i.srcsetAttr) : d.setAttribute(i.srcsetAttr, a.srcset.join(", ")), Object.defineProperty(d, "_lazyrias", { value: a, writable: !0 }) } } function g(a, b) { var e = d(a, b); return j.modifyOptions.call(a, { target: a, details: e, detail: e }), c.fire(a, "lazyriasmodifyoptions", e), e } function h(a) { return a.getAttribute(a.getAttribute("data-srcattr") || j.srcAttr) || a.getAttribute(i.srcsetAttr) || a.getAttribute(i.srcAttr) || a.getAttribute("data-pfsrcset") || "" } var i, j, k = { string: 1, number: 1 }, l = /^\-*\+*\d+\.*\d*$/, m = /^picture$/i, n = /\s*\{\s*width\s*\}\s*/i, o = /\s*\{\s*height\s*\}\s*/i, p = /\s*\{\s*([a-z0-9]+)\s*\}\s*/gi, q = /^\[.*\]|\{.*\}$/, r = /^(?:auto|\d+(px)?)$/, s = b.createElement("a"), t = b.createElement("img"), u = "srcset" in t && !("sizes" in t), v = !!a.HTMLPictureElement && !u; !function () { var b, d = function () { }, e = { prefix: "", postfix: "", srcAttr: "data-src", absUrl: !1, modifyOptions: d, widthmap: {}, ratio: !1, traditionalRatio: !1, aspectratio: !1 }; i = c && c.cfg || a.lazySizesConfig, i || (i = {}, a.lazySizesConfig = i), i.supportsType || (i.supportsType = function (a) { return !a }), i.rias || (i.rias = {}), "widths" in (j = i.rias) || (j.widths = [], function (a) { for (var b, c = 0; !b || b < 3e3;)c += 5, c > 30 && (c += 1), b = 36 * c, a.push(b) }(j.widths)); for (b in e) b in j || (j[b] = e[b]) }(), addEventListener("lazybeforesizes", function (a) { if (a.detail.instance == c) { var b, d, e, k, l, m, o, p, q, s, t, u, x; if (b = a.target, a.detail.dataAttr && !a.defaultPrevented && !j.disabled && (q = b.getAttribute(i.sizesAttr) || b.getAttribute("sizes")) && r.test(q)) { if (d = h(b), e = g(b, d), t = n.test(e.prefix) || n.test(e.postfix), e.isPicture && (k = b.parentNode)) for (l = k.getElementsByTagName("source"), m = 0, o = l.length; m < o; m++)(t || n.test(p = h(l[m]))) && (f(p, e, l[m]), u = !0); t || n.test(d) ? (f(d, e, b), u = !0) : u && (x = [], x.srcset = [], x.isPicture = !0, Object.defineProperty(b, "_lazyrias", { value: x, writable: !0 })), u && (v ? b.removeAttribute(i.srcAttr) : "auto" != q && (s = { width: parseInt(q, 10) }, w({ target: b, detail: s }))) } } }, !0); var w = function () { var d = function (a, b) { return a.w - b.w }, e = function (a) { var b, c, d = a.length, e = a[d - 1], f = 0; for (f; f < d; f++)if (e = a[f], e.d = e.w / a.w, e.d >= a.d) { !e.cached && (b = a[f - 1]) && b.d > a.d - .13 * Math.pow(a.d, 2.2) && (c = Math.pow(b.d - .6, 1.6), b.cached && (b.d += .15 * c), b.d + (e.d - a.d) * c > a.d && (e = b)); break } return e }, f = function (a, b) { var d; return !a._lazyrias && c.pWS && (d = c.pWS(a.getAttribute(i.srcsetAttr || ""))).length && (Object.defineProperty(a, "_lazyrias", { value: d, writable: !0 }), b && a.parentNode && (d.isPicture = "PICTURE" == a.parentNode.nodeName.toUpperCase())), a._lazyrias }, g = function (b) { var d = a.devicePixelRatio || 1, e = c.getX && c.getX(b); return Math.min(e || d, 2.4, d) }, h = function (b, c) { var h, i, j, k, l, m; if (l = b._lazyrias, l.isPicture && a.matchMedia) for (i = 0, h = b.parentNode.getElementsByTagName("source"), j = h.length; i < j; i++)if (f(h[i]) && !h[i].getAttribute("type") && (!(k = h[i].getAttribute("media")) || (matchMedia(k) || {}).matches)) { l = h[i]._lazyrias; break } return (!l.w || l.w < c) && (l.w = c, l.d = g(b), m = e(l.sort(d))), m }, j = function (d) { if (d.detail.instance == c) { var e, g = d.target; if (!u && (a.respimage || a.picturefill || lazySizesConfig.pf)) return void b.removeEventListener("lazybeforesizes", j); ("_lazyrias" in g || d.detail.dataAttr && f(g, !0)) && (e = h(g, d.detail.width)) && e.u && g._lazyrias.cur != e.u && (g._lazyrias.cur = e.u, e.cached = !0, c.rAF(function () { g.setAttribute(i.srcAttr, e.u), g.setAttribute("src", e.u) })) } }; return v ? j = function () { } : addEventListener("lazybeforesizes", j), j }() });
}

var onSale = false;
var soldOut = false;
var priceVaries = false;
var images = [];
var firstVariant = {};
// Override Settings
var boostPFSFilterConfig = {
	general: {
		limit: boostPFSThemeConfig.custom.products_per_page,
		/* Optional */
		loadProductFirst: true,
		// Placeholder
		showPlaceholderProductList: true,
		placeholderProductPerRow: 3,
        placeholderProductGridItemClass: 'boost-pfs-filter-product-item boost-pfs-filter-product-item-grid boost-pfs-filter-grid-width-3 boost-pfs-filter-grid-width-mb-2',
        enableOTP: true,
        separateRefineByFromFilter: true,
        //filterTreeMobileStyle: 'style2', // 'style2', 'style3',
        enable_equal_height: boostPFSThemeConfig.custom.enable_equal_height,
        cropImagePossitionEqualHeight: boostPFSThemeConfig.custom.equal_height_crop_image_position
	},
    selector: {
      otpButtons:'.boost-pfs-filter-product-item-image-link'
    }
};

if (document.querySelector("body").classList.contains("product-customizable-product")) {
	boostPFSFilterConfig.general.loadProductFirst = false;
	boostPFSFilterConfig.general.paginationType = "load_more";
	boostPFSFilterConfig.general.filterTreeMobileStyle = "style2";
}
(function() {
	BoostPFS.inject(this);
	/************************** CUSTOMIZE DATA BEFORE BUILDING PRODUCT ITEM **************************/
	function prepareShopifyData(data) {
		// Displaying price base on the policy of Shopify, have to multiple by 100
		soldOut = !data.available; // Check a product is out of stock
		onSale = data.compare_at_price_min > data.price_min; // Check a product is on sale
		priceVaries = data.price_min != data.price_max; // Check a product has many prices
		// Convert images to array
		images = data.images_info;
		// Get First Variant (selected_or_first_available_variant)
		var firstVariant = data['variants'][0];
		if (Utils.getParam('variant') !== null && Utils.getParam('variant') != '') {
			var paramVariant = data.variants.filter(function(e) {
				return e.id == Utils.getParam('variant');
			});
			if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0];
		} else {
			for (var i = 0; i < data['variants'].length; i++) {
				if (data['variants'][i].available) {
					firstVariant = data['variants'][i];
					break;
				}
			}
		}
		return data;
	}
	/************************** END CUSTOMIZE DATA BEFORE BUILDING PRODUCT ITEM **************************/
	/************************** BUILD PRODUCT LIST **************************/
	// Build Product Grid Item
	let couner_prod = 0;
	ProductGridItem.prototype.compileTemplate = function(data) {
		if (!data) data = this.data;

		// Customize API data to get the Shopify data
		data = prepareShopifyData(data);

		if (document.querySelector("body").classList.contains("product-customizable-product")) {
			let template = this.buildCustomizationProductCard(data);

			return template;
		}
		else {
			// Get Template
			couner_prod+=1;

			let count_class = 'even';
			if((couner_prod+1)%3 == 0 ){
				count_class="odd"
			}


			var itemHtml = boostPFSTemplate.productGridItemHtml;

			// Add Custom class
			var soldOutClass = soldOut ? boostPFSTemplate.soldOutClass : '';
			var saleClass = onSale ? boostPFSTemplate.saleClass : '';
			itemHtml = itemHtml.replace(/{{soldOutClass}}/g, soldOutClass);
			itemHtml = itemHtml.replace(/{{saleClass}}/g, saleClass);
			itemHtml = itemHtml.replace(/{{counterProduct}}/g, count_class);
			// Add Grid Width class
			itemHtml = itemHtml.replace(/{{gridWidthClass}}/g, buildGridWidthClass(data));
			// Add Label
			itemHtml = itemHtml.replace(/{{itemLabels}}/g, buildLabels(data));
			// Add TAG Label
			itemHtml = itemHtml.replace(/{{itemTagLabels}}/g, buildTagLabels(data, false));
			// Add Images
			itemHtml = itemHtml.replace(/{{itemImages}}/g, buildImages(data));
			// Add Price
			itemHtml = itemHtml.replace(/{{itemPrice}}/g, buildPrice(data));

			//
			var itemHtmlQuickAdd = boostPFSTemplate.productGridItemQuickAdd;

			if (data.options.length == 1 && data.options[0] == 'size') {
				itemHtml = itemHtml.replace(/{{quickAdd}}/g, buildQuickAdd(data));
			} else {
				itemHtml = itemHtml.replace(/{{quickAdd}}/g, '');
			}

			// Add Review
			var itemReviewHtml = '<span class="shopify-product-reviews-badge" data-id="{{itemId}}"></span>';
			itemHtml = itemHtml.replace(/{{itemReviewHtml}}/g, itemReviewHtml);
			itemHtml = itemHtml.replace(/{{itemProduct}}/g, data);
			// Add Vendor
			itemHtml = itemHtml.replace(/{{itemVendor}}/g, buildVendor(data));
			// itemActiveSwapClass
			var itemActiveSwapClass = boostPFSThemeConfig.custom.active_image_swap ? 'has-bc-swap-image' : '';
			itemHtml = itemHtml.replace(/{{itemActiveSwapClass}}/g, itemActiveSwapClass);
			// Add Color Swatches
			itemHtml = itemHtml.replace(/{{itemColorSwatches}}/g, buildColorSwatches(data));
			// Add Variants
			itemHtml = itemHtml.replace(/{{itemVariants}}/g, buildListVariant(data));
			// Add Variants Options
			itemHtml = itemHtml.replace(/{{itemVariantsSelect}}/g, buildListVariantSelect(data));
			// Add Brands
			itemHtml = itemHtml.replace(/{{itemBrand}}/g, buildBrandLogo(data));
			// Add CUSTOM QUICK VIEW
			itemHtml = itemHtml.replace(/{{itemQuickView}}/g, buildCustomQuick(data));
			// Add CUSTOM SALE
			itemHtml = itemHtml.replace(/{{itemCustomSale}}/g, buildCustomSale(data));
			// Add CUSTOM NEW
			itemHtml = itemHtml.replace(/{{itemCustomNew}}/g, buildCustomNew(data));
			// Add CUSTOM PRE ORDER
			itemHtml = itemHtml.replace(/{{itemCustomPreOrder}}/g, buildCustomPreOrder(data));


			// Add data json

				itemHtml = itemHtml.replace(/{{itemJson}}/g, JSON.stringify(data.json));

			// Add main attribute (Always put at the end of this function)
			itemHtml = itemHtml.replace(/{{itemId}}/g, data.id);
			itemHtml = itemHtml.replace(/{{itemTitle}}/g, data.title);
			itemHtml = itemHtml.replace(/{{itemHandle}}/g, data.handle);
			itemHtml = itemHtml.replace(/{{itemVendorLabel}}/g, data.vendor);
			itemHtml = itemHtml.replace(/{{itemUrl}}/g, Utils.buildProductItemUrl(data, false));
		
			return itemHtml;
		}
	};
	// Build Product List Item
	FilterResult.prototype.afterRender = function (data, eventType) {
		if (!data) data = this.data;
		if (!eventType) eventType = this.eventType;

		var paginationTotal = $('.boost-pfs-filter-load-more-total-bottom');
		var paginationTopTotal = $('.boost-pfs-filter-load-more-total-top');
		var productsCurrent = Globals.queryParams.page <= 1

			? 1
			: (Globals.queryParams.page - 1) * Globals.queryParams.limit + 1;

		var productsCount =
			Globals.queryParams.page <= 0

				? data.products.length
				: (Globals.queryParams.page - 1) * Globals.queryParams.limit +
				data.products.length;

		paginationTotal.html(
			`Showing ${productsCount} of ${this.totalProduct} results`
		);

		paginationTopTotal.html(
			`${productsCurrent} - ${productsCurrent + data.products.length - 1} of ${this.totalProduct} items`
		);

		if (document.querySelector("body").classList.contains("product-customizable-product")) {
			const customizableProduct = $('.boost-pfs-filter-load-more-total');

			customizableProduct.html(
				`${productsCurrent} - ${productsCurrent + data.products.length - 1} of ${this.totalProduct} items`
			);
		}
	};

	ProductListItem.prototype.compileTemplate = function(data) {
		if (!data) data = this.data;
		// For List View

		if (!document.querySelector("body").classList.contains("product-customizable-product")) {
				/*** Prepare data ***/
			var images = data.images_info;
			// Displaying price base on the policy of Shopify, have to multiple by 100
			var soldOut = !data.available; // Check a product is out of stock
			var onSale = data.compare_at_price_min > data.price_min; // Check a product is on sale
			var priceVaries = data.price_min != data.price_max; // Check a product has many prices
			// Get First Variant (selected_or_first_available_variant)
			var firstVariant = data['variants'][0];
			if (Utils.getParam('variant') !== null && Utils.getParam('variant') != '') {
				var paramVariant = data.variants.filter(function(e) {
					return e.id == Utils.getParam('variant');
				});
				if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0];
			} else {
				for (var i = 0; i < data['variants'].length; i++) {
					if (data['variants'][i].available) {
						firstVariant = data['variants'][i];
						break;
					}
				}
			}
			/*** End Prepare data ***/
			// Get Template
			var itemHtml = boostPFSTemplate.productListItemHtml;
			data = prepareShopifyData(data);

			// Add Custom class
			var soldOutClass = soldOut ? boostPFSTemplate.soldOutClass : '';
			var saleClass = onSale ? boostPFSTemplate.saleClass : '';
			itemHtml = itemHtml.replace(/{{soldOutClass}}/g, soldOutClass);
			itemHtml = itemHtml.replace(/{{saleClass}}/g, saleClass);
			// Add Grid Width class
			itemHtml = itemHtml.replace(/{{gridWidthClass}}/g, buildGridWidthClass(data));
			// Add Label
			itemHtml = itemHtml.replace(/{{itemLabels}}/g, buildLabels(data));
			// Add TAG Label
			itemHtml = itemHtml.replace(/{{itemTagLabels}}/g, buildTagLabels(data, false));
			// Add Images
			itemHtml = itemHtml.replace(/{{itemImages}}/g, buildImages(data));
			// Add Price
			itemHtml = itemHtml.replace(/{{itemPrice}}/g, buildPrice(data));

			// Add Review
			var itemReviewHtml = '<span class="shopify-product-reviews-badge" data-id="{{itemId}}"></span>';
			itemHtml = itemHtml.replace(/{{itemReviewHtml}}/g, itemReviewHtml);
			itemHtml = itemHtml.replace(/{{itemProduct}}/g, data);
			// Add Vendor
			itemHtml = itemHtml.replace(/{{itemVendor}}/g, buildVendor(data));
			// itemActiveSwapClass
			var itemActiveSwapClass = boostPFSThemeConfig.custom.active_image_swap ? 'has-bc-swap-image' : '';
			itemHtml = itemHtml.replace(/{{itemActiveSwapClass}}/g, itemActiveSwapClass);
			// Add Color Swatches
			itemHtml = itemHtml.replace(/{{itemColorSwatches}}/g, buildColorSwatches(data));
			// Add Variants
			itemHtml = itemHtml.replace(/{{itemVariants}}/g, buildListVariant(data));
			// Add Variants Options
			itemHtml = itemHtml.replace(/{{itemVariantsSelect}}/g, buildListVariantSelect(data));
			// Add Brands
			itemHtml = itemHtml.replace(/{{itemBrand}}/g, buildBrandLogo(data));
			// Add CUSTOM QUICK VIEW
			itemHtml = itemHtml.replace(/{{itemQuickView}}/g, buildCustomQuick(data));
			// Add CUSTOM SALE
			itemHtml = itemHtml.replace(/{{itemCustomSale}}/g, buildCustomSale(data));
			// Add CUSTOM NEW
			itemHtml = itemHtml.replace(/{{itemCustomNew}}/g, buildCustomNew(data));
			// Add CUSTOM PRE ORDER
			itemHtml = itemHtml.replace(/{{itemCustomPreOrder}}/g, buildCustomPreOrder(data));


			// Add data json

				itemHtml = itemHtml.replace(/{{itemJson}}/g, JSON.stringify(data.json));

			// Add main attribute (Always put at the end of this function)
			itemHtml = itemHtml.replace(/{{itemId}}/g, data.id);
			itemHtml = itemHtml.replace(/{{itemTitle}}/g, data.title);
			itemHtml = itemHtml.replace(/{{itemHandle}}/g, data.handle);
			itemHtml = itemHtml.replace(/{{itemVendorLabel}}/g, data.vendor);
			itemHtml = itemHtml.replace(/{{itemUrl}}/g, Utils.buildProductItemUrl(data, false));
			// Customize API data to get the Shopify data
			// data = prepareShopifyData(data);
			// // Add Custom class
			// var soldOutClass = soldOut ? boostPFSTemplate.soldOutClass : '';
			// var saleClass = onSale ? boostPFSTemplate.saleClass : '';
			// itemHtml = itemHtml.replace(/{{soldOutClass}}/g, soldOutClass);
			// itemHtml = itemHtml.replace(/{{saleClass}}/g, saleClass);
			// // Add Label
			// itemHtml = itemHtml.replace(/{{itemLabels}}/g, buildLabels(data));
			// // Add TAG Label
			// itemHtml = itemHtml.replace(/{{itemTagLabels}}/g, buildTagLabels(data, false));
			// // Add Images
			// itemHtml = itemHtml.replace(/{{itemImages}}/g, buildImages(data));
			// // Add Review
			// var itemReviewHtml = '<span class="shopify-product-reviews-badge" data-id="{{itemId}}"></span>';
			// itemHtml = itemHtml.replace(/{{itemReviewHtml}}/g, itemReviewHtml);
			// // Add Vendor
			// itemHtml = itemHtml.replace(/{{itemVendor}}/g, buildVendor(data));
			// // Add Price
			// var itemPriceHtml = buildPrice(data, onSale, priceVaries);
			// itemHtml = itemHtml.replace(/{{itemPrice}}/g, itemPriceHtml);
			// // Description
			// var itemDescription = jQ('<p>' + data.body_html + '</p>').text();
			// itemDescription = (itemDescription.split(" ")).length > 35 ? itemDescription.split(" ").splice(0, 35).join(" ") + '...' : itemDescription.split(" ").splice(0, 35).join(" ");
			// itemHtml = itemHtml.replace(/{{itemDescription}}/g, itemDescription);
			// // itemActiveSwapClass
			// var itemActiveSwapClass = boostPFSThemeConfig.custom.active_image_swap ? 'has-bc-swap-image' : '';
			// itemHtml = itemHtml.replace(/{{itemActiveSwapClass}}/g, itemActiveSwapClass);
			// // Add Color Swatches
			// itemHtml = itemHtml.replace(/{{itemColorSwatches}}/g, buildColorSwatches(data));

			// // Add main attribute
			// itemHtml = itemHtml.replace(/{{itemTitle}}/g, data.title);
			// itemHtml = itemHtml.replace(/{{itemVendorLabel}}/g, data.vendor);
			// itemHtml = itemHtml.replace(/{{itemUrl}}/g, Utils.buildProductItemUrl(data, false));
			// itemHtml = itemHtml.replace(/{{itemId}}/g, data.id);
		}
		
		return itemHtml;
		// End For List View
	};

	ProductGridItem.prototype.buildCustomizationProductCard = function(product) {
		if (!product) {
			return "";
		}

		let variants = product.variants;

		let template = "";

		variants.forEach(variant => {			
			if (!variant.available) {
				return "";
			}

			template += this.getTemplate(product, variant);
		});

		return template;
	}
	/************************** END BUILD PRODUCT LIST **************************/
	/************************** BUILD PRODUCT ITEM ELEMENTS **************************/
	ProductGridItem.prototype.getTemplate = function (product, variant) {
		let template = boostPFSTemplate.customizableCard;

		let currentCustomizationId = document.querySelector("[data-modal-pop-up]").getAttribute("data-modal-pop-up") * 1;

		let productImage = this.buildCustomizationImage(product, variant);
		let productTitle = this.buildCustomizationTitle(product, variant);
		let productInput = this.buildCustomizationInput(product,variant, currentCustomizationId);
		let productLabel = this.buildCustomizationLabelData(variant);
		let productSelected = this.buildCustomizationProductClasses(variant, currentCustomizationId);
		let productLabelPlaceholder = this.buildCustomizationProductLabelText(variant, currentCustomizationId);

		template = template.replace(/{{selected}}/, productSelected);
		template = template.replace(/{{productImage}}/, productImage);
		template = template.replace(/{{productTitle}}/, productTitle);
		template = template.replace(/{{productInputData}}/, productInput);
		template = template.replace(/{{productlabelData}}/, productLabel); 
		//
		template = template.replace(/{{productPrice}}/, variant.price);
		template = template.replace(/{{label}}/, productLabelPlaceholder);

		return template;
	};

	ProductGridItem.prototype.buildCustomizationImage = function (product, variant) {		

		let productImage = "";

		if (variant.image) {
			productImage = variant.image;
		}
		else {
			productImage = product.images_info[0].src;
		}

		return `<picture>
			<source srcset="${productImage} 1x, ${productImage.replace(".png", "_600x.png")} 2x">
			
			<img srcset="${productImage} 1x, ${productImage.replace(".png", "_600x.png")} 2x"
				src="${productImage}"
				class="customizable-product-card__image"
			/>
		</picture>`;
	}

	ProductGridItem.prototype.buildCustomizationTitle = function (product, variant) {
		let option_title;

		variant.options.forEach((element, index) => {
			if (index != 0) {
				option_title += " / " + element;
			}
			else {
				option_title = element;
			}
		});

		let title = product.title + ` - ${option_title}`;

		return `${title}`;
	} 

	ProductGridItem.prototype.buildCustomizationInput = function(product, variant, currentCustomizationId) {
		let option_title;

		variant.options.forEach((element, index) => {
			if (index != 0) {
				option_title += " / " + element;
			} else {
				option_title = element;
			}
		});

		let productTitle = product.title + ` - ${option_title}`;

		let productImage = "";
		let src = "";
		let selectedSrc = "";
		let bigImageSrc = "";
		let customizationImageMini = "";
		let customizationBigImagesSrcset = "";
		let url = product.images_info[0].src;
		let checked = "";

		let fileFormat = url.split(/[#?]/)[0].split('.').pop().trim();

		if (variant.image) {
			productImage = variant.image;
		}
		else {
			productImage = product.images_info[0].src;
		}
		
		if (variant.id === currentCustomizationId) {
			checked = "checked"
		}

		src = productImage.replace(`.${fileFormat}`, `_300x.${fileFormat}`);
		selectedSrc = productImage.replace(`.${fileFormat}`,`_82x110.${fileFormat}`);
		bigImageSrc = productImage.replace(`.${fileFormat}`,`_2000x.${fileFormat}`);
		customizationImageMini = productImage.replace(`.${fileFormat}`,`_102x.${fileFormat}`);
		customizationBigImagesSrcset = `${productImage.replace(`.${fileFormat}`,`_200x.${fileFormat}`)} 200w,
			${productImage.replace(`.${fileFormat}`,`_400x.${fileFormat}`)} 400w,
			${productImage.replace(`.${fileFormat}`,`_600x.${fileFormat}`)} 600w,
			${productImage.replace(`.${fileFormat}`,`_800x.${fileFormat}`)} 800w,
			${productImage.replace(`.${fileFormat}`,`_1200x.${fileFormat}`)} 1200w,
			${productImage.replace(`.${fileFormat}`,`_2000x.${fileFormat}`)} 2000w
		`

		return `
			${checked}
			id="Customization-${variant.id}"
			value="${variant.id}"
			data-customization-title='${productTitle}'
			data-customization-price="${variant.price}"
			data-customization-image="${selectedSrc}"
			data-customization-image-mini="${customizationImageMini}"
			data-customization-big-images-src="${bigImageSrc}"
			data-customization-big-images-srcset="${customizationBigImagesSrcset}"
			data-customization-handle="${product.handle}"
		`;
	}

	ProductGridItem.prototype.buildCustomizationLabelData = function (variant) {
		return `for="Customization-${variant.id}"`
	}

	ProductGridItem.prototype.buildCustomizationProductClasses = function(variant, currentCustomizationId) {
		let selectedClass = "";

		if 	(variant.id == currentCustomizationId) {
			selectedClass = "selected";
		}

		return selectedClass; 
	}

	ProductGridItem.prototype.buildCustomizationProductLabelText = function(variant, currentCustomizationId) {
		let labelText = "select";

		if 	(variant.id == currentCustomizationId) {
			labelText = "selected";
		}

		return labelText; 
	}

	function buildGridWidthClass() {
		var gridWidthClass = '';
		// On PC
		switch (boostPFSThemeConfig.custom.products_per_row) {
			case 2:
				gridWidthClass = 'boost-pfs-filter-grid-width-2';
				break;
			case 3:
				gridWidthClass = 'boost-pfs-filter-grid-width-3';
				break;
			case 5:
				gridWidthClass = 'boost-pfs-filter-grid-width-5';
				break;
			default:
				gridWidthClass = 'boost-pfs-filter-grid-width-4';
				break;
		}
		// On Mobile
		switch (boostPFSThemeConfig.custom.products_per_row_mobile) {
			case 1:
				gridWidthClass += ' boost-pfs-filter-grid-width-mb-1';
				break;
			case 3:
				gridWidthClass += ' boost-pfs-filter-grid-width-mb-3';
				break;
			default:
				gridWidthClass += ' boost-pfs-filter-grid-width-mb-2';
				break;
		}
		return gridWidthClass;
	}

	function buildImages(data) {
	  var html = '';
	  // Build Main Image
	  var thumbUrl = Utils.getFeaturedImage(images, '260x');
	//   html += '<img class="abc boost-pfs-filter-product-item-main-image lazyload Image--lazyLoad"' +
	// 	  'data-srcset="' + Utils.getFeaturedImage(images, '180x') + " " + '180w' + ', ' + Utils.getFeaturedImage(images, '260x') + " " + '260w' + ', ' + Utils.getFeaturedImage(images, '360x') + " " + '360w' + '" ' +
	// 	  'data-src="' + thumbUrl + '" ' +
	// 	  'data-widths="[180, 260, 360]" ' +
	// 	  'data-sizes="auto" ' +
	// 	  'src="data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==" ' +
	// 	  'alt="{{itemTitle}}" />';
		for(let i=1; i<=data.images_info.length; i++){
			let image_alt = data.title.split('"');

			html += `
				<div class="gallery-cell" data-thumb="" data-title="${data.title}" data-image-width="750px">
					<a href="{{itemUrl}}" class="image__container" style="max-width: 750px">
						<img
							alt="${image_alt[0]}"
							class="lazyload"
							data-index="${i}"
							data-image-id="${data.images_info[i-1].id}"
							data-sizes="auto"
							src="//cdn.shopify.com/s/files/1/2720/0882/files/product-holder-grey.svg?873"
							data-src="${Utils.optimizeImage(data.images_info[i-1].src, '750x')}"
							data-srcset="
								${Utils.optimizeImage(data.images_info[i-1].src, '230x')} 230w,
								${Utils.optimizeImage(data.images_info[i-1].src, '250x')} 250w,
								${Utils.optimizeImage(data.images_info[i-1].src, '400x')} 400w,
								${Utils.optimizeImage(data.images_info[i-1].src, '500x')} 500w,
								${Utils.optimizeImage(data.images_info[i-1].src, '600x')} 600w,
								${Utils.optimizeImage(data.images_info[i-1].src, '750x')} 750w
							"
						/>
					</a>
				</div>
			`;
		}

	  // Build Image Swap
	  if (boostPFSThemeConfig.custom.active_image_swap) {
		  var flipImageUrl = images.length > 1 ? Utils.optimizeImage(images[1]['src'],'260x') : thumbUrl;
		  var flipImageSrcset = images.length > 1 ? Utils.optimizeImage(images[1]['src'], '180x') + " " + '180w' + ', ' + Utils.optimizeImage(images[1]['src'], '260x') + " " + '260w' + ', ' + Utils.optimizeImage(images[1]['src'], '360x') + " " + '360w' : Utils.getFeaturedImage(images, '180x') + " " + '180w' + ', ' + Utils.getFeaturedImage(images, '260x') + " " + '260w' + ', ' + Utils.getFeaturedImage(images, '360x') + " " + '360w';
		  html += '<img class="boost-pfs-filter-product-item-flip-image lazyload Image--lazyLoad"' +
		  'data-srcset="' + flipImageSrcset + '" ' +
		  'data-src="' + flipImageUrl + '" ' +
		  'data-widths="[180, 260, 360]" ' +
		  'data-sizes="auto" ' +
		  'src="' + flipImageUrl + '" ' +
		  'alt="{{itemTitle}}" />';
	  }
	  return html;
  }

	function buildVendor(data) {
		var html = '';
		if (boostPFSThemeConfig.custom.show_vendor) {
			html = boostPFSTemplate.vendorHtml;
		}
		return html;
	}

	function buildPrice(data) {
		var html = '';
		if (boostPFSThemeConfig.custom.show_price) {
			html = '<p class="boost-pfs-filter-product-item-price">';
			if (onSale) {

				html += '<span class="boost-pfs-filter-product-item-sale-price">' + Utils.formatMoney(data.price_min) + '</span>';
				html += '<s>' + Utils.formatMoney(data.compare_at_price_min) + '</s> ';
			} else {
				if (priceVaries) {
					html += '<span class="boost-pfs-filter-product-item-price-from-text">' + (boostPFSThemeConfig.label_basic.from) + ' '+ '</span>';
				}
				html += '<span class="boost-pfs-filter-product-item-regular-price">' + Utils.formatMoney(data.price_min) + '</span>';
			}
			html += '</p>';
		}
		return html;
	}

	function buildQuickAdd(data) {
		var html = boostPFSTemplate.productGridItemQuickAdd;
		html = html.replace(/{{itemVariants}}/g, buildListVariant(data));

		return html;
	}

	function buildLabels(data) {
		// Build Sold out label
		var soldOutLabel = '';
		if (boostPFSThemeConfig.custom.show_sold_out_label && soldOut) {
			soldOutLabel = boostPFSTemplate.soldOutLabelHtml.replace(/{{style}}/g, '');
		}
		// Build Sale label
		var saleLabel = '';
		if (boostPFSThemeConfig.custom.show_sale_label && onSale && !soldOut) {
			saleLabel = boostPFSTemplate.saleLabelHtml.replace(/{{style}}/g, '');
		}
		// Build Labels
		return soldOutLabel + saleLabel;
	}
	// BUILD LABEL PRODUCT WITH TAGS
	function buildTagLabels(data, showall) {
		if (showall) {
			var tagLabel = '';
			if (data.tags) {
				for (var i = 0; i < data.tags.length; i++) {
					var tag = data.tags[i];
					if (tag.indexOf("pfs:label") !== -1) {
						var preTagLabel = boostPFSTemplate.tagLabelHtml.replace(/{{labelTag}}/g, tag.split('pfs:label-')[1]);
						tagLabel += preTagLabel;
					}
				}
			}
		} else {
			var tagLabel = '';
			if (data.tags) {
				for (var i = data.tags.length - 1; i >= 0; i--) {
					tag = data.tags[i];
					if (tag.indexOf("pfs:label") !== -1) {
						var preTagLabel = boostPFSTemplate.tagLabelHtml.replace(/{{labelTag}}/g, tag.split('pfs:label-')[1]);
						tagLabel += preTagLabel;
						break;
					}
				}
			}
		}
		return tagLabel;
	}

	// Build Color Swatches
	function buildColorSwatches(data) {
		var colorSwatchesHtml = '';
		if (boostPFSThemeConfig.custom.display_item_swatch) {
			colorSwatchesHtml += '<ul class="boost-pfs-filter-item-swatch">';
			for (var index = 0; index < data.options.length; index++) {
				var option = data['options'][index].toLowerCase();
				if (option == 'color') {
					var colorlist = '';
					var color = '';
					var totalVariants = 0;
					for (var k = 0; k < data.variants.length; k++) {
						var variant = data['variants'][k];
						color = variant['options'][index];
						if (colorlist.indexOf(color) == -1) {
							if (totalVariants < 4) {
								var text = Utils.slugify(color);
								var border = text == 'white' ? 'border: 1px solid #cbcbcb;' : '';
								var backgroundImage = Utils.optimizeImage(variant.image, '24x');
								var dataImg = '';
								var dataColor = '#fff';
								dataColors = variant.option_color.toLowerCase().split(' ');
								var i = dataColors.length - 1;
								if (dataColors[i] !== '' && dataColors[i] !== 'colors') {
									dataColor = dataColors[i];
								}

								// if (variant.image !== null) {
								// 	dataImg = "data-img='" + Utils.optimizeImage(variant.image) + "'";
								// } else {
								// 	var _file = variant.option_color.toLowerCase().replace(/ /g, '-');
								// 	backgroundImage = boostPFSAppConfig.general.file_url.split('?')[0] + 'color-' + _file + '.png';
								// }

								var _file = variant.option_color.toLowerCase().replace(/ /g, '-');
								backgroundImage = boostPFSAppConfig.general.file_url.split('?')[0] + 'color-' + _file + '.png?v=' + boostPFSAppConfig.general.file_url.split('?')[1];

								colorSwatchesHtml += '<li>';
								colorSwatchesHtml += '<div class="tooltip">' + color + '</div>';
								colorSwatchesHtml += '<label style="' + border + ' background-color: ' + dataColor + '; background-image: url(' + backgroundImage + ');" ' + dataImg + '></label>';

								//colorSwatchesHtml += '<label style="' + border + 'background-image: url(' + Utils.optimizeImage(variant.image, '24x') + ');"' + if (variant.image !== null){ + 'data-img="' + Utils.optimizeImage(variant.image) + '"' + } '></label>';
								colorSwatchesHtml += '</li>';

							}
							var templist = colorlist + color + ' ';
							colorlist = templist;

							totalVariants++;

						}
					}
					// if (totalVariants == 1) {
					// colorSwatchesHtml = '<ul class="boost-pfs-filter-item-swatch">';
					// }
					if (totalVariants > 4) {
						colorSwatchesHtml += '<li class="boost-pfs-filter-item-swatch-more">';
						colorSwatchesHtml += '<a href="{{itemUrl}}" title="More Color">+' + (totalVariants - 4) + '</a>';
						colorSwatchesHtml += '</li>';
						totalVariants = 0;
					}
				}
			}
			colorSwatchesHtml += '</ul>';
		}
		return colorSwatchesHtml;
	}

	// Build Brand Logo
	function buildBrandLogo(data) {

       var handle, imgUrl, imgName,imagePath, collectionUrl;
		var BrandImgHtml = '';

		handleize = function (str) {
			str = str.toLowerCase();

			var toReplace = ['"', "'", "\\", "(", ")", "[", "]"];

			// For the old browsers
			for (var i = 0; i < toReplace.length; ++i) {
				str = str.replace(toReplace[i], "");
			}

			str = str.replace(/\W+/g, "-");

			if (str.charAt(str.length - 1) == "-") {
				str = str.replace(/-+\z/, "");
			}

			if (str.charAt(0) == "-") {
				str = str.replace(/\A-+/, "");
			}

			return str
		};

		BrandImgHtml += '<div class="vnd_img product-grid-item__brand-image">';

           if (data.vendor) {
           	   handle = handleize(data.vendor);
           	   imgName = `logo6-${handle}.png`;
           	   imagePath = boostPFSAppConfig.general.file_url.split('?')[0] + imgName;
           	   collectionUrl = encodeURIComponent(data.vendor).replace('%20','-').toLowerCase();

			   BrandImgHtml += `<a href="/collections/${collectionUrl}" class="vendor_img" title="Shop ${data.vendor}"><img src="data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==" data-src="${imagePath}" width="35" class="lazyload" alt="${data.vendor}"/></a>`;
		   }


		// if (boostPFSThemeConfig.custom.display_item_brand) {
		// 	colorVariantsHtml += '<div class="product-brand__custom">';
		//
		// 	// for (var index = 0; index < data.options.length; index++) {
		// 	// 	var option = data['options'][index].toLowerCase();
		// 	// 	if (option == 'size') {
		// 	// 		for (var k = 0; k < data.variants.length; k++) {
		// 	// 			var quantity = data.variants[k].inventory_quantity;
		// 	// 			var title = data.variants[k].title;
		// 	// 			if (1 > quantity) {
		// 	// 				colorVariantsHtml += '<span class="black">' + title + '</span>';
		// 	// 			}else if (1 == quantity){
		// 	// 				colorVariantsHtml += '<span class="orange" title="One Left">' + title + '</span>';
		// 	// 			}else if (1 < quantity) {
		// 	// 				colorVariantsHtml += '<span class="green" title="In Stock">' + title + '</span>';
		// 	//
		// 	// 			}
		// 	// 		}
		// 	// 	}
		// 	// }
		// 	colorVariantsHtml += '</div>';
		// }

		BrandImgHtml += '</div>';
		return BrandImgHtml;
	}

// <span class="quick_shop ss-icon js-quick-shop-link"
// 	data-no-instant
// 	data-remodal-target="quick-shop"
// 	data-id="{{ product.id }}"
// 	data-handle="{{ product.handle }}"
// 	data-money-format="{{ shop.money_format }}"
// 	data-single-variant="{% if product.has_only_default_variant %}true{% else %}false{% endif %}"
// 	data-url="{{ product.url | within: collection }}"
// 	data-title="{{ product.title | escape }}"
// 	data-details-text="{{ 'collections.general.view_product_details_html' | t | escape}}"
// 	data-full-description="{{ product.description | split: '<!-- split -->' | first | escape }}"
// 	data-regular-description="{{ product.description | strip_html | truncatewords: settings.description_words | replace: 'Description', '' | replace: 'Dimensions', '' | replace: 'Details', '' | replace: 'Specs', '' | replace: 'Shipping', '' | replace: 'Size', '' | escape }}"
// 	data-images="{% for image in product.images %}{{ image.id }} || {{ image.alt | escape }} ||{% endfor %}"
// 	data-collection-handles="{{ collection_handles | join: ','}}"
// 		>
// 		{{ 'collections.general.quick_shop' | t }}
// </span>
	// Custom Quick Button
	function buildCustomQuick(data) {

      let QuickViewHtml = '';
      let single_variant = false;
	  let numWords = boostPFSThemeConfig.custom.truncate;

		function truncate(str, no_words) {
			return str.split(" ").splice(0,no_words).join(" ");
		}


		if (data.description) {
			var data_description = 	data.description.split('<!-- split -->');
			var truncated_desc =  truncate(data.description,numWords);
		}else {
			var data_description = '';
			var truncated_desc = '';
		}


      let images = '';
      if (data.variants.length > 1) {
		  single_variant = true;
	  }



		for (var i = 0; i < data.images_info.length; i++) {
      	     images +=`${data.images_info[i].id} || ${data.title} ||`;
	  }

		var collections_handles = data.collections.map(obj => obj.handle);

		QuickViewHtml += `<span class="quick_shop ss-icon js-quick-shop-link" 
		data-no-instant
		data-remodal-target="quick-shop"
		data-id="${data.id}"
		data-handle="${data.handle}"
		data-money-format="${boostPFSAppConfig.shop.money_format}"
		data-single-variant="${single_variant}"
		data-url="/products/${data.handle}"
		data-title="${data.title}"
		data-details-text="${boostPFSThemeConfig.translate.view_details}"
       	data-full-description="${data_description[data_description.length - 1]}"
       	data-regular-description="${truncated_desc}"
       	data-images="${images}"
       	data-collection-handles="${collections_handles.join(',')}"
       	data-get-form="/products/${data.handle}?view=boost-pfs-quickview"
		>
		${boostPFSThemeConfig.translate.quick_view_button}</span>
		`;

      return QuickViewHtml;
		}


	// Custom NEW LABEL
	function buildCustomNew(data) {

		let badge_html = '';
		let label_text = boostPFSThemeConfig.custom_badges.new_badge;

		jQ.each(data.collections, function (value, index) {
			if (this.handle == 'new') {
				badge_html += `<div class="new_banner thumbnail_banner">${label_text}</div>`;
				return false;
			}

		});
		return badge_html;
	}

    // Custom PRE ORDER
	function buildCustomPreOrder(data) {

		let badge_html = '';
		let label_text = boostPFSThemeConfig.custom_badges.pre_badge;

		jQ.each(data.collections, function (value, index) {
			if (this.handle == 'pre-order') {
				badge_html += `<div class="preorder_banner thumbnail_banner">${label_text}</div>`;
				return false;
			}

		});
		return badge_html;
	}


	// Custom SALE LABEL
	function buildCustomSale(data) {

		let badge_html = '';
		let label_text = boostPFSThemeConfig.custom_badges.sale_badge;

		if (onSale) {
			badge_html += `<div class="sale_banner thumbnail_banner">${label_text}</div>`;
		}

		return badge_html;
	}


	// Build Variants
	function buildListVariant(data) {

		var colorVariantsHtml = '';
		if (boostPFSThemeConfig.custom.display_item_variants) {
			colorVariantsHtml += '';
			for (var index = 0; index < data.options.length; index++) {
				var option = data['options'][index].toLowerCase();
				if (option == 'size' & data.options.length == 1) {
					for (var k = 0; k < data.variants.length; k++) {
						var quantity = data.variants[k].inventory_quantity;

						var title = data.variants[k].title;
					    if (1 > quantity) {
							colorVariantsHtml += ``;
						}else if (1 == quantity){
							colorVariantsHtml += `<input id="swatch-0-${title}-${data.id}-collection-template" type="radio" name="option-0" value="${title}"><div data-value="${title}" data-variant-id="${data.variants[k].id}" class='swatch-element ${title}-swatch available'> <label for="swatch-0-${title}-${data.id}-collection-template">
							${title} <span class="crossed-out"></span></label></div>`;
					    }else if (1 < quantity) {
							colorVariantsHtml += `<input id="swatch-0-${title}-${data.id}-collection-template" type="radio" name="option-0" value="${title}"><div data-value="${title}" data-variant-id="${data.variants[k].id}" class='swatch-element ${title}-swatch available'> <label for="swatch-0-${title}-${data.id}-collection-template">
							${title} <span class="crossed-out"></span></label></div>`;

						}
					}
				}
			}
			colorVariantsHtml += '';
		}
		return colorVariantsHtml;
	}

	// Build select variants
	function buildListVariantSelect(data) {
		var optionVariantsHtml = '';
		if (boostPFSThemeConfig.custom.display_item_variants) {
			optionVariantsHtml += '';
			for (var k = 0; k < data.variants.length; k++) {
				var quantity = data.variants[k].inventory_quantity;
				var title = data.variants[k].title;
				if (1 > quantity) {
					optionVariantsHtml += ``;
				}else {
					optionVariantsHtml += `<option value="${data.variants[k].id}">${title}</option>`;
				}
			}
			optionVariantsHtml += '';
		}
		return optionVariantsHtml;
	}

	// Build Color Swatches
	function eventColorSwatches() {
		jQ('.boost-pfs-filter-item-swatch li label').each(function(){
			var img = jQ(this).parents('.boost-pfs-filter-product-item-inner').find('.boost-pfs-filter-product-item-main-image');
			jQ(this).hover(function(){
				var newImage = jQ(this).data('img');
				img.attr('srcset', newImage);
			});
		});


	}

	/************************** END BUILD PRODUCT ITEM ELEMENTS **************************/
	/************************** BUILD TOOLBAR **************************/
	// Build Pagination
	ProductPaginationDefault.prototype.compileTemplate = function(totalProduct) {
		if (!totalProduct) totalProduct = this.totalProduct;
		// Get page info
		var currentPage = parseInt(Globals.queryParams.page);
		var totalPage = Math.ceil(totalProduct / Globals.queryParams.limit);
		// If it has only one page, clear Pagination
		if (totalPage <= 1) {
			return '';
		}
		if (Settings.getSettingValue('general.paginationType') == 'default') {
			var paginationHtml = boostPFSTemplate.paginateHtml;
			// Build Previous
			var previousHtml = (currentPage > 1) ? boostPFSTemplate.previousActiveHtml : boostPFSTemplate.previousDisabledHtml;
			previousHtml = previousHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, currentPage - 1));
			paginationHtml = paginationHtml.replace(/{{previous}}/g, previousHtml);
			// Build Next
			var nextHtml = (currentPage < totalPage) ? boostPFSTemplate.nextActiveHtml : boostPFSTemplate.nextDisabledHtml;
			nextHtml = nextHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, currentPage + 1));
			paginationHtml = paginationHtml.replace(/{{next}}/g, nextHtml);
			// Create page items array
			var beforeCurrentPageArr = [];
			for (var iBefore = currentPage - 1; iBefore > currentPage - 3 && iBefore > 0; iBefore--) {
				beforeCurrentPageArr.unshift(iBefore);
			}
			if (currentPage - 4 > 0) {
				beforeCurrentPageArr.unshift('...');
			}
			if (currentPage - 4 >= 0) {
				beforeCurrentPageArr.unshift(1);
			}
			beforeCurrentPageArr.push(currentPage);
			var afterCurrentPageArr = [];
			for (var iAfter = currentPage + 1; iAfter < currentPage + 3 && iAfter <= totalPage; iAfter++) {
				afterCurrentPageArr.push(iAfter);
			}
			if (currentPage + 3 < totalPage) {
				afterCurrentPageArr.push('...');
			}
			if (currentPage + 3 <= totalPage) {
				afterCurrentPageArr.push(totalPage);
			}
			// Build page items
			var pageItemsHtml = '';
			var pageArr = beforeCurrentPageArr.concat(afterCurrentPageArr);
			for (var iPage = 0; iPage < pageArr.length; iPage++) {
				if (pageArr[iPage] == '...') {
					pageItemsHtml += boostPFSTemplate.pageItemRemainHtml;
				} else {
					pageItemsHtml += (pageArr[iPage] == currentPage) ? boostPFSTemplate.pageItemSelectedHtml : boostPFSTemplate.pageItemHtml;
				}
				pageItemsHtml = pageItemsHtml.replace(/{{itemTitle}}/g, pageArr[iPage]);
				pageItemsHtml = pageItemsHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, pageArr[iPage]));
			}
			paginationHtml = paginationHtml.replace(/{{pageItems}}/g, pageItemsHtml);
			return paginationHtml;
		}
	};

	// Build Sorting
	ProductSorting.prototype.compileTemplate = function() {
		var html = '';
		if (boostPFSThemeConfig.custom.show_sorting && boostPFSTemplate.hasOwnProperty('sortingHtml')) {
			var sortingArr = Utils.getSortingList();
			if (sortingArr) {
				var paramSort = Globals.queryParams.sort || '';
				// Build content
				var sortingItemsHtml = '';
				for (var k in sortingArr) {
					activeClass = '';
					if(paramSort == k) {
						activeClass = 'boost-pfs-filter-sort-item-active';
					}
					sortingItemsHtml += '<li><a href="#" data-sort="' + k + '" class="' + activeClass+ '">' + sortingArr[k] + '</a></li>';
				}
				html = boostPFSTemplate.sortingHtml.replace(/{{sortingItems}}/g, sortingItemsHtml);
			}
		}
		return html;
	};

	ProductSorting.prototype.render = function() {
		jQ(Selector.topSorting).html(this.compileTemplate());

		if (jQ('.boost-pfs-filter-custom-sorting').hasClass('boost-pfs-filter-sort-active')) {
			jQ('.boost-pfs-filter-custom-sorting').toggleClass('boost-pfs-filter-sort-active');
		}

		var labelSort = '';
		var paramSort = Globals.queryParams.sort || '';
		if (paramSort.length > 0) {
			var labelHandle = 'sorting_' + paramSort.replace(/\-/g, '_');
			labelSort = Labels[labelHandle];
		} else {
			labelSort = Labels.sorting_heading;
		}



		jQ('.boost-pfs-filter-custom-sorting button span span').text(labelSort);
		let current_page = jQ('.boost-pfs-filter-pagination-active').text();
		let total = jQ('.totalProduct-total').first().text();
		let pagination_limit = boostPFSThemeConfig.label.pagination_limit;
		jQ('.boost-pfs-filter-toolbar-count-top .totalProduct-start').text(pagination_limit*current_page - pagination_limit +1);
		let total_count = pagination_limit*current_page;


		if(total_count > total){
			jQ('.boost-pfs-filter-toolbar-count-top .totalProduct-finish').text(total);
			jQ('.totalProduct-show').text(total - (pagination_limit*(current_page-1)));
		}else{
			jQ('.boost-pfs-filter-total-product .totalProduct-finish').text(pagination_limit*current_page);
			jQ('.totalProduct-show').text(pagination_limit);
		}

		if (!document.querySelector("body").classList.contains("product-customizable-product")) {
			initProductImageFlickity();
		}
	}

	// Build Sorting event
	ProductSorting.prototype.bindEvents = function() {
		var _this = this;
		jQ('.boost-pfs-filter-filter-dropdown a').click(function(e){
			e.preventDefault();
			FilterApi.setParam('sort', jQ(this).data('sort'));
			FilterApi.setParam('page', 1);
			FilterApi.applyFilter('sort');
		});

		jQ(".boost-pfs-filter-custom-sorting > button").click(function(){
			if (!jQ('.boost-pfs-filter-filter-dropdown').is(':animated')) {
				jQ('.boost-pfs-filter-filter-dropdown').toggle().parent().toggleClass('boost-pfs-filter-sort-active');
				//jQ('.boost-pfs-filter-tree-v').hide();
			}
		});

		jQ(Selector.filterTreeMobileButton).click(function(){
			jQ('.boost-pfs-filter-top-sorting-mobile .boost-pfs-filter-filter-dropdown').hide();
		});
	};
	// For Toolbar - Build Display type
	ProductDisplayType.prototype.compileTemplate = function() {
		var itemHtml = '<span>' + boostPFSThemeConfig.label.toolbar_viewas + '</span>';
		itemHtml += '<a href="' + Utils.buildToolbarLink('display', 'list', 'grid') + '" title="Grid view" class="{{class.productDisplayType}}-item {{class.productDisplayType}}-grid" data-view="grid"><span class="icon-fallback-text"><span class="fallback-text">Grid view</span></span></a>';
		itemHtml += '<a href="' + Utils.buildToolbarLink('display', 'grid', 'list') + '" title="List view" class="{{class.productDisplayType}}-item {{class.productDisplayType}}-list" data-view="list"><span class="icon-fallback-text"><span class="fallback-text">List view</span></span></a>';
		itemHtml = itemHtml.replace(/{{class.productDisplayType}}/g, Class.productDisplayType);

		return itemHtml;
	};

	// Build Show Limit
	ProductLimit.prototype.compileTemplate = function() {
		var html = '';
		if (boostPFSThemeConfig.custom.show_limit && boostPFSTemplate.hasOwnProperty('showLimitHtml')) {

			var numberList = Settings.getSettingValue('general.showLimitList');
			if (numberList != '') {
				// Build content
				var showLimitItemsHtml = '';
				var arr = numberList.split(',');
				for (var k in sortingArr) {
					showLimitItemsHtml += '<option value="' + arr[k].trim() + '">' + arr[k].trim() + '</option>';
				}
				html = boostPFSTemplate.showLimitHtml.replace(/{{showLimitItems}}/g, showLimitItemsHtml);
			}
		}
		return html;
	};
	// Build Breadcrumb
	Breadcrumb.prototype.compileTemplate = function (colData) {
		if (!colData) colData = this.collectionData;
		var breadcrumbItemsHtml = '';
		if (boostPFSTemplate.hasOwnProperty('breadcrumbHtml')) {
			if (typeof colData !== 'undefined' && colData.hasOwnProperty('collection')) {
				var colInfo = colData.collection;
				if (typeof this.collectionTags !== 'undefined' && this.collectionTags !== null) {
					breadcrumbItemsHtml += boostPFSTemplate.breadcrumbItemLink.replace(/{{itemLink}}/g, '/collections/' + colInfo.handle).replace(/{{itemTitle}}/g, colInfo.title);
					breadcrumbItemsHtml += " {{breadcrumbDivider}} ";
					breadcrumbItemsHtml += boostPFSTemplate.breadcrumbItemSelected.replace(/{{itemTitle}}/g, this.collectionTags[0]);
				} else {
					breadcrumbItemsHtml += boostPFSTemplate.breadcrumbItemSelected.replace(/{{itemTitle}}/g, colInfo.title);
				}
			} else {
				breadcrumbItemsHtml += boostPFSTemplate.breadcrumbItemSelected.replace(/{{itemTitle}}/g, Settings.getSettingValue('label.defaultCollectionHeader'));
			}
		}
		return breadcrumbItemsHtml
	};
	/************************** END BUILD TOOLBAR **************************/
	function matchHeightImage() {
		// jQ('.boost-pfs-filter-product-item-main-image').load(function() {
		// 	var imageContainer = jQ(this).parent();
		// 	imageContainer.css('width', '100%').css('height', jQ(this).height());
		// }).each(function() {
		// 	if (this.complete) jQ(this).load();
		// });
	}

	// Add additional feature for product list, used commonly in customizing product list
	ProductList.prototype.afterRender = function (data) {
		eventColorSwatches();
		let $ = jQ;

		if (!data) data = this.data;

		if($('body.collection').length>0 || $('body.search').length>0){

			$(document).ready(function(event){

			  $('.product_form_quick_add .swatch-element').on('click',function(event) {
				 $(this).closest('form.shopify-product-form').find('input[checked]').removeAttr('checked');
				let val = $(this).attr('data-value');
				$(this).closest('form.shopify-product-form').find(`input[value="${val}"]`).attr('checked', 'true');
			  let variantId = $(this).attr('data-variant-id');

				var $addToCartForm =  $(this).closest('form.shopify-product-form');
				var $addToCartBtn = $addToCartForm.find('.add_to_cart');

				let regexp = /&id=(.*?)&/g;
				let dataStr = $addToCartForm.serialize().replace(regexp, `&id=${variantId}&`) + `&id=${variantId}&quantity=1`;
				$.ajax({
				  url: '/cart/add.js',
				  dataType: 'json',
				  cache: false,
				  type: 'post',
				  data: dataStr,
				  beforeSend: function() {
					$addToCartBtn.attr('disabled', 'disabled').addClass('disabled');
					$addToCartBtn.find('span').removeClass("fadeInDown").addClass('animated zoomOut');
				  },
				  success: function(itemData) {
					$addToCartBtn.find('.checkmark').addClass('checkmark-active');

					window.setTimeout(function(){
					  $addToCartBtn.removeAttr('disabled').removeClass('disabled');
					  $addToCartBtn.find('.checkmark').removeClass('checkmark-active');
					  $addToCartBtn.find('span').removeClass('zoomOut').addClass('fadeInDown');
					}, 1000);

					$.ajax({
					  url: '/cart.js',
					  dataType: "json",
					  cache: false,
					  success: function(cart) {

						    $(".cart_count").empty();
						$cartBtn = $(".cart_count");
						var value = $cartBtn.text() || '0';
						var cart_items_html = "";
						var cart_action_html = "";
						var cart_savings_html = "";
						var $cart = $(".cart_content form");
						var discounted_price_total = 0;
						var total_savings = 0;

						$cartBtn.text(value.replace(/[0-9]+/,cart.item_count));

						if (cart.item_count == 0) {
							$('.cart_content--header').addClass('hidden');
							$('.js-empty-cart__message').removeClass('hidden');
							$('.js-cart_content__form').addClass('hidden');
							$('.upsell_bolck').addClass('hidden_upsel');
						} else {
							$('.cart_content--header').removeClass('hidden');
							$('.js-empty-cart__message').addClass('hidden');
							$('.js-cart_content__form').removeClass('hidden');
							$('.upsell_bolck').removeClass('hidden_upsel');

						$.each(cart.items, function(index, item) {
							var line_id = index + 1;
							cart_items_html += '<li class="cart_item clearfix">';
							if (item.image) {
								cart_items_html += '<a href="' + item.url +'"><div class="cart_image">';

								let item_vendor =  'logo-' + item.vendor.replace(' ', '-') + ".png";
								item_vendor = item_vendor.replace('-& ', '-');
								item_vendor = item_vendor.replace(' ', '-');

								let logo_icon_url =  '//cdn.shopify.com/s/files/1/2720/0882/files/' + item_vendor.toLowerCase();
								cart_items_html += '<div class="brand_icon"> <img src="' + logo_icon_url + '"> </div>';


								cart_items_html += '<img src="' + item.image.replace(/(\.[^.]*)$/, "_compact$1").replace('http:', '') + '" alt="' + htmlEncode(item.title) + '" />' +
								'</div></a>';
							}


							cart_items_html += '<div class="cart_item__title"><div class="item_title">' + item.product_title + '</div></div>';
							cart_items_html += '<div class="cart_item__options">';
							for (let index = 0; index < item.options_with_values.length; index++) {
								const option = item.options_with_values[index];
								if (option.value != 'Default Title') {
									cart_items_html += ' <span class="item_option">'+ option.name +': '+ option.value +'</span>';
								}
							}
							cart_items_html += '</div>';
							if(item.properties) {
							cart_items_html += '<div class="cart_item__options">';
							$.each(item.properties, function(title, value) {
								if (value) {
								cart_items_html += '<span class="item_option">' + title +': ' + value + '</span>';
								}
							});
							cart_items_html += '</div>';
							}
							cart_items_html += '<div class="bottom_item_minicart_elements"><div class="left product-quantity-box">' +
							'<span class="ss-icon product-minus js-change-quantity" data-func="minus"><span class="icon-minus"></span></span>' +
							'<input type="number" min="0" class="quantity" name="updates[]" id="updates_' + item.id + '" value="' + item.quantity +'" data-line-id="' + line_id +'" />' +
							'<span class="ss-icon product-plus js-change-quantity" data-func="plus"><span class="icon-plus"></span></span>' +
							'<span class="cart_item--remove icon js-change-quantity" data-func="remove">'+
							'<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">'+
								'<g fill="none" fill-rule="evenodd">'+
									'<g fill="#000" fill-rule="nonzero">'+
										'<g>'+
											'<g>'+
												'<path d="M14.123 3.819c.309 0 .56.25.56.56v1.258h2.581l.074.006c.026-.004.053-.006.08-.006h1.883c.31 0 .56.251.56.56 0 .31-.25.56-.56.56h-1.509l-.71 12.736c-.017.296-.262.528-.56.528h-9.52c-.296 0-.542-.231-.558-.528L5.72 6.757H4.213c-.309 0-.56-.25-.56-.56 0-.309.251-.56.56-.56h1.899l.072.004c.022-.002.044-.004.067-.004h2.58l.001-1.258c0-.31.25-.56.56-.56h4.73zm2.549 2.938H6.843l.689 12.144h8.461l.679-12.144zm-7.966.916c.287-.017.533.203.55.49l.532 9.322c.017.287-.202.532-.489.549-.287.016-.532-.203-.549-.49l-.533-9.322c-.017-.287.203-.533.49-.55zm6.08 0c.287.016.507.262.49.548l-.527 9.323c-.017.287-.262.506-.55.49-.286-.016-.505-.262-.489-.549l.528-9.322c.016-.287.262-.506.549-.49zm-3.031-.001c.287 0 .52.233.52.52v9.323c0 .287-.233.52-.52.52-.288 0-.52-.233-.52-.52V8.192c0-.287.232-.52.52-.52zm1.808-2.733H9.952v.698h3.61v-.698z" transform="translate(-1386 -145) translate(1056) translate(330 145)"/>'+
											'</g>'+
										'</g>'+
									'</g>'+
								'</g>'+
							'</svg>'+
							'</span>' +
						'</div>';

						cart_items_html += '<strong class="right price">';


								$.ajax({
									dataType: "json",
									async: false,
									cache: false,
									url: "/products/" + item.handle + ".js",
									success: function(data) {
									var variant_id = item.variant_id;
									var variant = $.grep(data.variants, function(v) {
										return v.id == variant_id;
									});

									if(variant[0] && variant[0].compare_at_price > item.price) {
										cart_items_html += ' <span class="money was_price">' + Shopify.formatMoney(variant[0].compare_at_price, $('body').data('money-format')) + '</span> ';
										discounted_price_total += item.price * item.quantity;
										total_savings += variant[0].compare_at_price * item.quantity;
									}
									}
								});

							cart_items_html += '<span class="money">' + Shopify.formatMoney(item.price, $('body').data('money-format')) + '</span></strong></div>' + '</div>';

							$('.left.product-quantity-box').css({
							'position': 'absolute',
							'bottom': '-7.5px'
							});
							$('.cart_item--remove.icon.js-change-quantity').css({
							'position': 'absolute',
							'top': '-127px',
							'right': '-79px'
							});

							$('.was-price > .money').css('text-decoration', 'line-through !important');
						}); // end foreach cart item


						}

						$('.ajax-cart-header--content span').text(cart.item_count);
						$('.js-cart_items').html(cart_items_html);
						$('.js-cart_subtotal').html(cart_action_html);
						$('.js-cart_savings').html(cart_savings_html);

						if (cart.item_count == 0){
						$('.js-cart-shipping').addClass('hidden')
						} else {
						$('.js-cart-shipping').removeClass('hidden')
						}


						var shipping_title = "";
						var shipping = "";
						var cart_total = "";
						var shiping_data = boostPFSThemeConfig.custom.treshold_setting * 100;
						var shipping_price = boostPFSThemeConfig.custom.shipping_price * 100;
						if (shiping_data > cart.total_price ){
						shipping_title = '<p>'+ boostPFSThemeConfig.custom.shipping_threshold_message_start + ' <span class="money">' + Shopify.formatMoney( shiping_data - cart.total_price, $('body').data('money-format')) + '</span> '+ boostPFSThemeConfig.custom.shipping_threshold_message_end + '</p>'

							if (shipping_price < 0) {
								shipping = '<span>Calculated at checkout</span>';
								cart_total =  '<span class="money">' + Shopify.formatMoney(cart.total_price, $('body').data('money-format')) + '</div>';
							} else {
								shipping = '<span class="money">' + Shopify.formatMoney(shipping_price, $('body').data('money-format')) + '</div>';
								cart_total =  '<span class="money">' + Shopify.formatMoney(cart.total_price + shipping_price, $('body').data('money-format'))  + '</div>';
							}
						} else {
						shipping_title = '<p>Free Shipping</p>';
						shipping = "FREE";
						cart_total =  '<span class="money">' + Shopify.formatMoney(cart.total_price, $('body').data('money-format')) + '</div>';
						}
						$('.js-cart-shipping .cart-drawer__shipping-title').html(shipping_title);
						$('.bar-progress').width( cart.total_price / boostPFSThemeConfig.custom.treshold_persent + "%" )
						$('.js-cart_shipping .shipping_money').html(shipping)
						$('.all_total').html(cart_total);

						convertCurrencies();




						if($('html').hasClass("remodal-is-locked")) {
						  $('.remodal-close').click();
						}

						if($('#header').is(':visible')) {
						  $('#header .cart_container').addClass('active_link');
						} else if ($('.sticky_nav--stick').length) {
						  $('.sticky_nav .cart_container').addClass('active_link');
						} else {
						  $('.top_bar .cart_container').addClass('active_link');
						}

						//block scrolling on mobile
						if ($(window).width() <= 798) {
						  var $cart_container = $(this).parent();
						  if($cart_container.hasClass('active_link')) {
							$('body').addClass('blocked-scroll');
						  } else {
							$('body').addClass('blocked-scroll');
						  }
						}
					  }
					});
				  },
				  error: function(XMLHttpRequest) {
					var response = eval('(' + XMLHttpRequest.responseText + ')');
					response = response.description;
					$('.warning').remove();

					var warning = '<p class="warning animated bounceIn">' + response.replace('All 1 ', 'All ') + '</p>';
					$addToCartForm.after(warning);
					$addToCartBtn.removeAttr('disabled').removeClass('disabled');
				  }
				});

				return false;
			  });

			});

		  }

		if (!data) data = this.data;

		// Intergrate Review Shopify
		if (window.SPR) {
			window.SPR.initDomEls();
			window.SPR.loadBadges();
		}

		if (Globals.queryParams.display !== 'list') equalHeight(data);



	// Build additional elements
	Filter.prototype.afterRender = function(data) {
		if (!data) data = this.data;

		let current_page = jQ('.boost-pfs-filter-pagination-active').text();
		let pagination_limit = boostPFSThemeConfig.label.pagination_limit;

if(data.products.length<=data.products.length && data.products.length != pagination_limit){
	var totalProduct ='<span class="totalProduct-start">'+1+'</span> -<span class="totalProduct-finish">' + data.products.length + '</span> of <span class="totalProduct-total">' + data.total_product + '</span><span> ' + boostPFSThemeConfig.label.items_with_count_other + '</span>';
	var totalProductBottom = 'Showing <span class="totalProduct-show">'+(data.products.length) + '</span>  of <span>' + data.total_product + '</span><span> results </span>';


}
else if(pagination_limit>data.products.length){
	var totalProduct ='<span class="totalProduct-start">'+(pagination_limit*current_page - pagination_limit +1)+'</span> -<span class="totalProduct-finish">' + (pagination_limit*(current_page-1)+data.products.length) + '</span> of <span class="totalProduct-total">' + data.total_product + '</span><span> ' + boostPFSThemeConfig.label.items_with_count_other + '</span>';
	var totalProductBottom = 'Showing <span class="totalProduct-show">'+(data.products.length) + '</span>  of <span>' + data.total_product + '</span><span> results </span>';


}else{
	var totalProduct ='<span class="totalProduct-start">'+(pagination_limit*current_page - pagination_limit +1)+'</span> -<span class="totalProduct-finish">' + pagination_limit*current_page + '</span> of <span class="totalProduct-total">' + data.total_product + '</span><span> ' + boostPFSThemeConfig.label.items_with_count_other + '</span>';
	var totalProductBottom = 'Showing <span class="totalProduct-show">'+(pagination_limit) + '</span>  of <span>' + data.total_product + '</span><span> results </span>';

}

if($('.boost-pfs-filter-refine-by-wrapper').length>0){

	 $('.boost-pfs-filter-refine-by-wrapper').html($( ".boost-pfs-filter-refine-by-wrapper-v-js" ).clone(true).removeClass('boost-pfs-filter-refine-by-wrapper-v-js'));

	$('.boost-pfs-filter-refine-by-wrapper .boost-pfs-filter-option-label').on('click', function(e){

		let self = this;
		$('.boost-pfs-filter-refine-by-wrapper-v-js .boost-pfs-filter-option-label').each(function( index ) {
			if($(this).text() == $(self).text()){
				$(this).find('.boost-pfs-filter-button').trigger('click');
			}
		});
	})
}

  $('.boost-pfs-filter-button.boost-pfs-filter-option-view-more-action button').text('See more +');
		if (data.total_product == 1) {
			totalProduct = data.total_product + '<span> ' + boostPFSThemeConfig.label.items_with_count_one + '</span>';
		}
		jQ('.boost-pfs-filter-total-product').html(totalProduct);
		jQ('.boost-pfs-filter-toolbar-count-bottom .boost-pfs-filter-total-product').html(totalProductBottom);
		matchHeightImage();
		jQ(window).resize(function() {
			matchHeightImage();
		});



		};

		jQ('body').find('.boost-pfs-filter-skeleton-button').remove();

		// Prevent double tap on iOS
		var isiOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
		if (isiOS){
			Utils.isMobile()&&jQ(".boost-pfs-filter-product-item").find("a").on("touchstart",function(){isScrolling=!1}).on("touchmove",function(){isScrolling=!0}).on("touchend",function(){isScrolling||(window.location=jQ(this).attr("href"))});
		}

		// Fix image not loaded on mobile
		//(Utils.isMobile()||null!=navigator.userAgent.match(/iPad/i))&&(setTimeout(function(){jQ(".boost-pfs-filter-product-item-image img").each(function(){var a=jQ(this).attr("src")+"3";jQ(this).attr("src",a)})},200),setTimeout(function(){jQ(".boost-pfs-filter-product-item-image img").each(function(){var a=jQ(this).attr("src")+"3";jQ(this).attr("src",a)})},2e3));
	};

	ProductListPlaceholder.prototype.render = function() {
		// Set limit number for product skeleton
		var placeholderLimit = this.settings.productsPerRow || this.settings.placeholderProductPerRow;
		// Build placeholder items
		var placeholderItem = this.compileTemplate();
		this.$element = [];
		for (var i = 0; i < placeholderLimit; i++) {
		  this.$element.push(jQ(placeholderItem));
		}
		// Show placeholder before send filter request OR hide it after get filter data
		if (!this.isFetchedProductData) {
		  this.setShow();
		} else {
		  this.setHide();
		}
	}

	ProductListPlaceholder.prototype.compileTemplateExtra = function() {
		var display = Globals.queryParams.display
		switch (display) {
			case 'list':
			//Todo: Build placeholder for List mode
			var template = boostPFSTemplate.productListPlaceholderHtml;
			var imgRatioSetting = parseFloat(this.settings.placeholderImageRatio);
			var imgRatio = imgRatioSetting > 0 ? imgRatioSetting : 1.4; // It mean w1:h1.4
			/**
			 * Set product class for product skeleton (to set column, style, etc.)
			 * - If had defined product_grid_class in boostPFSThemeConfig => use this config ELSE use our setting
			 */
			break;
		}
		return template
		.replace(/{{class.filterProductSkeleton}}/g, Class.filterProductSkeleton)
		.replace(/{{class.filterSkeleton}}/g, Class.filterSkeleton)
		.replace(/{{class.filterSkeletonText}}/g, Class.filterSkeletonText)
		.replace(/{{paddingTop}}/g, imgRatio * 100)
	}

	/* Prevent conflict with theme vendor js */
	Array.prototype.insert = function(a, b) {}

    /* Math qual Height */
	function equalHeight(data) {
		if(boostPFSFilterConfig.general.enable_equal_height){
			var equal_i = -1;
	    var equal_els = [];
	    var equal_element = null;
	    var widthImage = jQ('.boost-pfs-filter-product-item').width();

	    var indexData = 0;
	    var cropImagePosition = boostPFSFilterConfig.general.cropImagePossitionEqualHeight;

	      // Equal Height Title
			jQ('.boost-pfs-filter-product-item').each(function(i, element) {

				var offsetTop = jQ(element).offset().top;
				if(!equal_element || equal_element.offset().top !== offsetTop) {
					equal_element = jQ(element);
					equal_i++;
				}

				if(!equal_els[equal_i]) {
					equal_els[equal_i] = [];
				}
				equal_els[equal_i].push(element);
			});

	      for(var i = 0; i < equal_els.length; i++) {
	        var max = 0;
	        var maxRatio = 0;
	        var iLength = equal_els[i].length;

	        for(var j = 0; j < equal_els[i].length; j++) {
	          var item = equal_els[i][j];
	          var height = jQ(item).find('.boost-pfs-filter-product-item-title').height();
	          max = Math.max(max, height);

	          indexData = (i * iLength) + j;
	          if (typeof(data[indexData]) != 'undefined') {
	            var images = data[indexData].images_info;
	            if(images.length > 0){
	              var ratioImage = images[0].height / images[0].width;
	              maxRatio = Math.max(maxRatio, ratioImage);
            	}
	          }
	        }

	        jQ(equal_els[i]).find('.boost-pfs-filter-product-item-title').css({'min-height': max});

	        var maxHeightImage = widthImage * maxRatio;
	        jQ(equal_els[i]).find('.boost-pfs-filter-product-item-image').css({'height': maxHeightImage}).addClass('boost-pfs-filter-crop-image-position-' + cropImagePosition);

	      }
    	}
    }

})();



/* Begin patch boost-010 run 2 */
Filter.prototype.beforeInit=function(){var t=this.isBadUrl();t&&(this.isInit=!0,window.location.href=window.location.pathname)},Filter.prototype.isBadUrl=function(){try{var t=decodeURIComponent(window.location.search).split("&"),e=!1;if(t.length>0)for(var n=0;n<t.length;n++){var i=t[n],r=(i.match(/</g)||[]).length,a=(i.match(/>/g)||[]).length,o=(i.match(/alert\(/g)||[]).length,h=(i.match(/execCommand/g)||[]).length;if(r>0&&a>0||r>1||a>1||o||h){e=!0;break}}return e}catch(l){return!0}};
/* End patch boost-010 run 2 */
if ($('body.search').length>0 ) {
	draggable = true;
} else {
	draggable = false;
}

if ($('.product_gallery').hasClass('product_gallery-collection') && $('.product_gallery').hasClass('multi-image') || $('body.search').length>0 ){

	if($(window).width()>1024){
	  draggable = false;
	}else{
	  draggable = true;
	}
  }
const initProductImageFlickity = function(){
		$('.product_gallery').flickity({
			"adaptiveHeight": true,
			"wrapAround": "true",
			"cellAlign": "left",
			"draggable": draggable,
			"contain": true,
			"imagesLoaded": true,
			"lazyLoad": 2,
			"pageDots": false,
			"prevNextButtons": true,
			"autoPlay": false,
			"selectedAttraction": 0.01,
			"friction": 0.15

		  });
}

if (!document.querySelector("body").classList.contains("product-customizable-product")) {	
	document.onreadystatechange = function(){
		if (document.readyState=='complete'){
			initProductImageFlickity();
		}
	}
}
